import { Box, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from '@material-ui/core'
import axios from 'axios'
import React, { useEffect, useState } from 'react'

const dateTime = (value) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Budapest', dateStyle: 'short', timeStyle: 'medium' }).format(new Date(value))

const ReservationHistory = ({ reservationId, management, reloadKey }) => {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(20)
  const [reload, setReload] = useState(0)
  const [state, setState] = useState({ loading: true, error: '', data: null })
  useEffect(() => {
    let active = true
    const request = axios.CancelToken.source()
    setState({ loading: true, error: '', data: null })
    axios
      .get(`vehicle-reservations/${management ? 'manage/' : ''}${reservationId}/history`, {
        params: { page, pageSize },
        cancelToken: request.token
      })
      .then(({ data }) => {
        if (!data.success || !Array.isArray(data.data?.events)) throw new Error('History unavailable')
        if (active) setState({ loading: false, error: '', data: data.data })
      })
      .catch((error) => {
        if (active)
          setState({ loading: false, data: null, error: error.response?.data?.message || 'Historiku nuk u ngarkua. Provoni përsëri.' })
      })
    return () => {
      active = false
      request.cancel('Reservation history closed or changed')
    }
  }, [reservationId, management, reloadKey, page, pageSize, reload])

  return (
    <Box mt={2} data-testid='reservation-history'>
      {state.loading && <Typography role='status'>Duke ngarkuar historikun…</Typography>}
      {state.error && (
        <Box>
          <Typography role='alert' color='error'>
            {state.error}
          </Typography>
          <Button onClick={() => setReload((value) => value + 1)}>Provo përsëri</Button>
        </Box>
      )}
      {state.data && (
        <>
          {state.data.events.length === 0 && <Typography>Nuk ka ngjarje në historik.</Typography>}
          <Box component='ol' aria-label='Historiku i rezervimit' m={0} p={0} style={{ listStyle: 'none' }}>
            {state.data.events.map((event) => (
              <Box component='li' key={event.id} border={1} borderColor='grey.300' borderRadius={4} p={2} mb={2}>
                <Typography variant='subtitle1'>{event.title}</Typography>
                <Typography variant='body2' color='textSecondary'>
                  {dateTime(event.at)} · {event.actor}
                </Typography>
                {event.subject && <Typography variant='body2'>Pasagjeri: {event.subject}</Typography>}
                {event.note && (
                  <Typography variant='body2' style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                    Shënimi: {event.note}
                  </Typography>
                )}
                {event.changes.length > 0 && (
                  <Box mt={1} style={{ overflowX: 'auto' }}>
                    <Table size='small' aria-label='Ndryshimet e ngjarjes'>
                      <TableHead>
                        <TableRow>
                          <TableCell>Fusha</TableCell>
                          <TableCell>Para</TableCell>
                          <TableCell>Pas</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {event.changes.map((change) => (
                          <TableRow key={change.field}>
                            <TableCell>{change.label}</TableCell>
                            <TableCell style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{change.before}</TableCell>
                            <TableCell style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{change.after}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
          <TablePagination
            component='div'
            count={state.data.total}
            page={page}
            rowsPerPage={pageSize}
            rowsPerPageOptions={[20, 50, 100]}
            labelRowsPerPage='Ngjarje për faqe:'
            nextIconButtonText='Faqja tjetër'
            backIconButtonText='Faqja e mëparshme'
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} nga ${count}`}
            onPageChange={(_, value) => setPage(value)}
            onRowsPerPageChange={(event) => {
              setPageSize(Number(event.target.value))
              setPage(0)
            }}
          />
        </>
      )}
    </Box>
  )
}

export default ReservationHistory
